// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".specifications-button--divider[data-v-2b9dfb4e]{align-items:center;display:flex}.specifications-button--divider-btn[data-v-2b9dfb4e]{background-color:transparent!important;border:1px solid #1976d2!important;box-shadow:none!important;color:#002788!important;font-size:14px!important;font-weight:700!important;padding:0 16px!important;text-transform:none!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
